import FourImg from "../images/4.jpg"
import FiveImg from "../images/6.jpg"
import SixImg from "../images/7.jpg"
import SevenImg from "../images/8.jpg"
import EightImg from "../images/9.jpg"
import NinImg from "../images/10.jpg"
import TenImg from "../images/11.jpg"
import LevelImg from "../images/12.jpg"
import twolevImg from "../images/13.jpg"







const seller = [
    {
        img:FourImg,
        name:"Mini fire pit",
        price:"₹244,00 /-"
    },
    {
        img:FiveImg,
        name:"Storage box ",
        price:"₹388,90 /-"
    },
    {
        img:SixImg,
        name:"Mini bad and Sofa",
        price:"₹312,33 /-"
    },
    {
        img:SevenImg,
        name:"Hot Sofa and Chars",
        price:"₹70,30 /-"
    },
    {
        img:EightImg,
        name:"Simple Sofa",
        price:"₹37,00 /?-"
    },
    {
        img:NinImg,
        name:"Dining Room",
        price:"₹13,000 /-"
    },
    {
        img:TenImg,
        name:"More comfortable",
        price:"₹4300 /-"
    },
    {
        img:FiveImg,
        name:"Good Sleeping",
        price:"₹23,300 /-"
    },
    

]

export {seller}